import { IMeta } from '@bees-web/core/types'
import { MouseEvent } from 'react'
import {
  setBrandsBanners,
  setSignedBanners,
  setSignedBannersMeta,
} from '../../actions/banners'
import { trackPartnerStoreCardViewed } from '../../actions/partners'
import { HomeInteractive } from '../../interfaces'
import { BannersInteractiveMap } from '../../interfaces/banners'
import {
  bannerOnClickSegment,
  bannerOnLoadSegment,
} from '../../utils/bannerSegmentEvents'
import { selectPartnerStore } from '../../utils/selectPartnerStore'
import { trackButtonClicked } from '../topdeals/topDeals'
import { LINK_PLANNING } from '../../app/constants'
import { getStoreId } from '@bees-web/web-shared-services'

export const signedSlider: HomeInteractive<BannersInteractiveMap> = (
  dispatch,
  interactiveState,
  globalActions
) => ({
  signed_homepage_onload_banners: {
    attributes: {
      onLoad: (args) => {
        const { meta, slides } = args
        dispatch(setSignedBannersMeta(meta))
        dispatch(setSignedBanners(slides))
      },
    },
  },
  signed_banner_image: {
    dependencies: [interactiveState.state.banners.slidesSigned],
    attributes: {
      onLoad: () => {
        const index = Number(
          document
            ?.querySelector('.slick-slide.slick-active.slick-current')
            ?.getAttribute('data-index')
        )

        const currentSlide =
          interactiveState.state.banners.slidesSigned?.[index]

        if (currentSlide?.viewed) return

        const newSlides = interactiveState.state.banners.slidesSigned?.map(
          (slide, slideIndex) => {
            if (slideIndex === index) {
              return {
                ...slide,
                viewed: true,
              }
            }

            return slide
          }
        )

        const banner = interactiveState.state?.banners?.slidesSigned?.find(
          (slide) => slide.index === index
        )

        const meta = {
          imageUrl: banner?.backgroundImage?.large,
          url: banner?.url,
          position: index + 1,
          quantity: interactiveState.state.banners.slidesSigned.length,
          referrer: interactiveState.globals.page.referrer,
          id: banner?.banner_id,
          name: banner?.label,
          type: banner?.banner_type,
          ...interactiveState.state.banners.meta,
        }

        bannerOnLoadSegment(meta, dispatch)
        dispatch(setSignedBanners(newSlides))
      },
    },
  },
  signed_banners_link: {
    attributes: {
      onClick: () => {
        const index = Number(
          document
            ?.querySelector('.slick-slide.slick-active.slick-current')
            ?.getAttribute('data-index')
        )

        const banner = interactiveState.state?.banners?.slidesSigned?.find(
          (slide) => slide.index === index
        )

        const meta = {
          imageUrl: banner?.backgroundImage?.large,
          url: banner?.url,
          position: index + 1,
          quantity: interactiveState.state.banners.slidesSigned.length,
          referrer: interactiveState.globals.page.referrer,
          id: banner?.banner_id,
          name: banner?.label,
          type: banner?.banner_type,
        }

        const mergedMeta = {
          ...meta,
          ...interactiveState.state.banners.meta,
          referrer: interactiveState.globals.page.referrer,
        }

        bannerOnClickSegment(mergedMeta, dispatch)
      },
    },
  },
  signed_banner_arrow: {
    attributes: {
      onClickArrow: (arrow) => {
        const { referrer } = interactiveState.globals.page
        const isKeyAccount =
          interactiveState.globals?.authentication?.selectedAccount
            ?.isKeyAccount
        const storeId = getStoreId()
        dispatch(
          trackButtonClicked({
            button_name: arrow === 'ChevronLeft' ? 'arrow back' : 'arrow next',
            button_label: 'banner',
            referrer,
            screen_name: 'Home',
            url: window.location.href,
            recommendation_type: null,
            module_name: null,
            store_id: storeId,
            value_stream: isKeyAccount ? LINK_PLANNING : 'HOMEPAGE',
          })
        )
      },
      onClickDots: () => {
        const { referrer } = interactiveState.globals.page
        const isKeyAccount =
          interactiveState.globals?.authentication?.selectedAccount
            ?.isKeyAccount
        const storeId = getStoreId()
        dispatch(
          trackButtonClicked({
            button_name: 'circles',
            button_label: 'banner',
            referrer,
            screen_name: 'Home',
            url: window.location.href,
            recommendation_type: null,
            module_name: null,
            store_id: storeId,
            value_stream: isKeyAccount ? LINK_PLANNING : 'HOMEPAGE',
          })
        )
      },
    },
  },
  signed_homepage_partner_slider: {
    attributes: {
      onClickChangeStore: (e: MouseEvent<HTMLButtonElement>, meta: IMeta) => {
        dispatch(setBrandsBanners([]))
        dispatch(setSignedBanners([]))
        selectPartnerStore(dispatch, interactiveState, globalActions, e, {
          ...meta,
          screen_name: interactiveState.globals.page.name,
        })
      },
      onLoadPartnerStoreCard: (meta: IMeta) => {
        const {
          selectedStore,
          cardStyle: card_style,
          cardsQuantity: cards_quantity,
          position,
          vendorId,
        } = meta

        dispatch(
          trackPartnerStoreCardViewed({
            card_style,
            cards_quantity,
            position,
            screen_name: interactiveState.globals.page.name,
            store_id: selectedStore.storeId,
            vendorId,
            referrer: interactiveState.globals.page.referrer,
          })
        )
      },
    },
  },
  signed_brand_slider: {
    attributes: {
      onClickSegment: (_e: MouseEvent<HTMLButtonElement>, meta: IMeta) => {
        bannerOnClickSegment(meta, dispatch)
      },
      onLoadSegment: (meta: IMeta) => {
        bannerOnLoadSegment(meta, dispatch)
      },
    },
  },
})
